module.exports = __webpack_public_path__ + "statics/img/11.a327b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/11.png
// module id = c2V1
// module chunks = 1